module.exports = __webpack_public_path__ + "static/media/privacyPolicyGreen.82f2162d.svg";